import "./index.css";
import { TimerCard } from "@/components/timercard/TimerCard";

export function App() {
  return <TimerCard />;
}

export default App;
